import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../Utility";

const initialState = {
  loading: false,
  error: null,
  data: [],
  filterData: [],
  message: null,
  page: null,
  editprofileDetail: null,
  editprofileDetailError: null,
  addEditError: null,
  addEditSuccess: null,
  addEditLoading: false,
  redirectTo: null,
  planList: [],
  roleList: [],
};

const editprofileListStart = (state) => {
  return updateObject(state, { loading: true, error: null, message: null });
};

const editprofileListFail = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: action.error,
    data: [],
    message: null,
  });
};

const editprofileListSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: null,
    data: action.page === 1 ? action.data : [...state.data, ...action.data],
    filterData:
      action.page === 1 ? action.data : [...state.filterData, ...action.data],
    message: action.message,
    page: action.page,
    redirectTo: null,
    editprofileDetail: null,
  });
};

const editprofileDetail = (state, action) => {
  return updateObject(state, {
    editprofileDetail: action.data,
    editprofileDetailError: action.error,
  });
};

const addEditStart = (state) => {
  return updateObject(state, {
    addEditError: null,
    addEditSuccess: null,
    addEditLoading: true,
  });
};

const addEditFail = (state, action) => {
  return updateObject(state, {
    addEditError: action.error,
    addEditLoading: false,
  });
};

const addEditSuccess = (state, action) => {
  return updateObject(state, {
    addEditSuccess: action.message,
    redirectTo: action.redirectTo,
    addEditLoading: false,
  });
};

const filterList = (state, action) => {
  const filterText = action.text.toLowerCase();
  const role = action.role.toLowerCase();
  const filteredItems = state.filterData.filter((item) => {
    const matchesText =
      (item.FirstName && item.FirstName.toLowerCase().includes(filterText)) ||
      (item.LastName && item.LastName.toLowerCase().includes(filterText)) ||
      (item.email && item.email.toLowerCase().includes(filterText));

    const matchesRole =
      (item.roleName && item.roleName.toLowerCase() === role) || role === "";

    return matchesText && matchesRole;
  });

  return updateObject(state, { data: filteredItems });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.EDIT_PROFILE_START:
      return editprofileListStart(state);
    case actionTypes.EDIT_PROFILE_FAIL:
      return editprofileListFail(state, action);
    case actionTypes.EDIT_PROFILE_SUCCESS:
      return editprofileListSuccess(state, action);
    case actionTypes.EDIT_PROFILE_DETAIL:
      return editprofileDetail(state, action);
    case actionTypes.EDIT_PROFILE_UPDATE_START:
      return addEditStart(state);
    case actionTypes.EDIT_PROFILE_UPDATE_FAIL:
      return addEditFail(state, action);
    case actionTypes.EDIT_PROFILE_UPDATE_SUCCESS:
      return addEditSuccess(state, action);

    default:
      return state;
  }
};

export default reducer;
